import React, { FC, useContext } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { Flex } from '@vio/atlas/helpers/Flex';
import { Icon } from '@vio/atlas/Icon';
import { HotelCardContext } from 'components/HotelCardContext';
import { getUserMeasurementSystem } from 'modules/meta/selectors';
import { getGeoDetails, getIsUserOrUrlLocationSearch, getPlaceCategory, getSearchDisplayName } from 'modules/search/selectors';
import { convertMilesToKm, getDistanceFromMessage, messages } from '@daedalus/core/src/utils/distanceFrom';
const _exp = /*#__PURE__*/() => Flex.Row;
const DistanceWrapper = /*#__PURE__*/styled(_exp())({
  name: "DistanceWrapper",
  class: "dfzu1w6",
  propsAsIs: true
});
const MessageWrapper = /*#__PURE__*/styled('div')({
  name: "MessageWrapper",
  class: "m14jvqd3",
  propsAsIs: false
});
interface Props {
  distance?: number;
}
export const DistanceFrom: FC<Props> = ({
  distance
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    hotelId
  } = useContext(HotelCardContext);
  const userMeasurementSystem = useSelector(getUserMeasurementSystem);
  const searchDisplayName = useSelector(getSearchDisplayName);
  const placeCategory = useSelector(getPlaceCategory);
  const {
    featureType: geoDetailsFeatureType,
    shortName: geoDetailsShortName
  } = useSelector(getGeoDetails) || {};
  const fromUserLocation = useSelector(getIsUserOrUrlLocationSearch);
  const distanceFromMessage = getDistanceFromMessage({
    fromUserLocation,
    geoDetailsFeatureType,
    geoDetailsShortName,
    placeCategory: placeCategory || 0
  });

  // Show nothing when distance or message not provided
  if (!distance || !distanceFromMessage) return null;
  const [unitMessage, convertedDistance] = userMeasurementSystem === 'imperial' ? [messages.distanceAsMiles, distance] : [messages.distanceAsKm, convertMilesToKm(distance)];
  const message = formatMessage(distanceFromMessage, {
    distance: convertedDistance.toFixed(1),
    unit: formatMessage(unitMessage),
    targetName: geoDetailsShortName ?? searchDisplayName
  });
  return <DistanceWrapper alignItems="flex-start">
      <Icon name="Walk" size="sm" />
      <MessageWrapper id={`HotelCardMobileDistanceFrom-${hotelId}`}>
        {message}
      </MessageWrapper>
    </DistanceWrapper>;
};

require("./DistanceFrom.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./DistanceFrom.tsx");